import React, { useState, useMemo, useRef, useEffect } from 'react';
import {
  Box,
  Grid,
  Button,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  IconButton,
  CircularProgress
} from '@mui/material'
import { Description, PictureAsPdf, Delete, Upload } from '@mui/icons-material';
import { AddEventContext } from '../../../contexts/addEvent.context'
import ReactQuill, { Quill } from 'react-quill';
import ImageUploader from 'quill-image-uploader';
import 'react-quill/dist/quill.snow.css';
import api , { baseURL } from '../../../services/api'
import { Document, Page, pdfjs  } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@5.3.31/build/pdf.worker.min.mjs';

const Partner = () => {
  const [editorType, setEditorType] = useState('quill');
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const pdfFile = useRef(null);
  const quillRef = useRef();
  const { eventDTO, activeStep, setActiveStep, setEventDTO } = React.useContext(AddEventContext)
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  async function handleInformation() {
    const partners = editorType === 'pdf' ? pdfUrl : value;
    setEventDTO({ ...eventDTO, partners })
    try {
      const newEvent = await api.post('/events', { data: { ...eventDTO, partners } })
      if (newEvent.status === 200) {
        setActiveStep(activeStep + 1)
      }
    } catch (error) {
      alert(`erro: ${error.message}`)
    }
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append('files', file);

        const response = await api.post('/upload', formData);
        pdfFile.current = response.data[0].id;
        const uploadedPdfUrl = `${baseURL}${response.data[0].url}`;
        console.log('PDF URL:', uploadedPdfUrl);
        setPdfUrl(uploadedPdfUrl);

      } catch (error) {
        alert(`Erro ao fazer upload: ${error.message}`);
      } finally {
        setLoading(false);
      }
    } else {
      alert('Por favor, selecione um arquivo PDF válido.');
    }
  };

  async function handleDeletePdf() {
    if (pdfFile.current) {
      try {
        setLoading(true);
        await api.delete(`/upload/files/${pdfFile.current}`);
        setPdfUrl(null);
        setEventDTO({ ...eventDTO, partners: "" })
        pdfFile.current = null;
      } catch (error) {
        alert(`Erro ao deletar PDF: ${error.message}`);
      } finally {
        setLoading(false);
      }
    }
  }

  useEffect(() => {
    if (quillRef.current) {
      Quill.register('modules/imageUploader', ImageUploader);
      setValue(eventDTO.partners)
    }
    return () => {
      quillRef.current = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['bold', 'italic', 'underline', "strike"],
        [{ 'list': 'ordered' }, { 'list': 'bullet' },
        { 'indent': '-1' }, { 'indent': '+1' }],
        ['image', "link",],
        [{ 'color': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466'] }]
      ],
      imageUploader: {
        upload: (file) => {
          return
        }
      }
    },
  }), [])

  return (
    <Box pb={2}>
      <Grid container spacing={2} columns={12} sx={{ mb: 5 }}>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography variant='h5'>Palestrantes</Typography>
            <ToggleButtonGroup
              value={editorType}
              exclusive
              onChange={(e, newValue) => newValue && setEditorType(newValue)}
              sx={{ ml: 2 }}
            >
              <ToggleButton value="quill" aria-label="editor">
                <Description /> Editor
              </ToggleButton>
              <ToggleButton value="pdf" aria-label="pdf">
                <PictureAsPdf /> PDF
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Grid>
        <Grid item xs={12}>
          {editorType === 'quill' ? (
            <ReactQuill
              ref={quillRef}
              value={value}
              style={{ height: "450px" }}
              modules={modules}
              onChange={setValue}
              theme='snow'
            />
          ) : (
            <Box
              sx={{
                border: '2px dashed #ccc',
                borderRadius: 2,
                p: 3,
                minHeight: 450,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {loading ? (
                <CircularProgress />
              ) : pdfUrl ? (
                <Box sx={{ width: '100%', height: '450px', position: 'relative', overflow: 'auto' }}>
                  <IconButton
                    onClick={() => handleDeletePdf()}
                    sx={{ position: 'absolute', top: 10, right: 10, zIndex: 1, bgcolor: 'background.paper' }}
                  >
                    <Delete color="error" />
                  </IconButton>
                  <Document
                    file={pdfUrl}
                    onDcumentLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    loading={<Box sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '100%'
                    }}>
                      <CircularProgress />
                      <Typography ml={2}>
                        Carregando PDF...
                      </Typography>
                    </Box>}
                  >
                    <Page
                      renderAnnotationLayer={false}
                      renderTextLayer={false}
                      pageNumber={pageNumber}
                      width={800}
                    />
                  </Document>
                  {numPages > 1 && (
                    <Box sx={{
                      position: 'sticky',
                      bottom: 0,
                      p: 1,
                      bgcolor: 'background.paper',
                      display: 'flex',
                      justifyContent: 'center',
                      gap: 2
                    }}>
                      <Button
                        disabled={pageNumber <= 1}
                        onClick={() => setPageNumber(prev => prev - 1)}
                      >
                        Anterior
                      </Button>
                      <Typography>
                        Página {pageNumber} de {numPages}
                      </Typography>
                      <Button
                        disabled={pageNumber >= numPages}
                        onClick={() => setPageNumber(prev => prev + 1)}
                      >
                        Próxima
                      </Button>
                    </Box>
                  )}
                </Box>
              ) : (
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<Upload />}
                >
                  Fazer Upload do PDF
                  <input
                    type="file"
                    hidden
                    accept="application/pdf"
                    onChange={handleFileUpload}
                  />
                </Button>
              )}
            </Box>
          )}
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={() => setActiveStep(activeStep - 1)}
          sx={{ mt: 3, ml: 1 }}
          color='warning'
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          color='success'
          onClick={handleInformation}
          sx={{ mt: 3, ml: 1 }}
        >
          Cadastrar Evento
        </Button>
      </Box>
    </Box>
  )
}

export default Partner;
